import { FaBars } from '@meronex/icons/fa';
import { useBreakpointIndex, Box, IconButton, getVariant } from '@apia/theme';
import usePortal from 'react-cool-portal';
import { FavoriteIcon } from '../FavoriteIcon';

export const HeaderButtons = () => {
  const breakPoint = useBreakpointIndex();
  const shouldShowAsFloat = breakPoint === 3;

  const { Portal: FloatPortal } = usePortal({
    containerId: 'NonControlledAppModals',
    clickOutsideToHide: false,
    autoRemoveContainer: false,
    defaultShow: true,
    escToHide: false,
  });

  return (
    <Box className="iconsBar">
      {breakPoint >= 4 && <FavoriteIcon />}
      {shouldShowAsFloat && (
        <FloatPortal>
          <Box {...getVariant('layout.twoColumnsAside.hamburguer')}>
            <IconButton
              title={window.TOGGLE_MENU}
              aria-label={window.TOGGLE_MENU}
              onClick={(ev) => {
                ev.stopPropagation();
              }}
              className="toggleMenu"
            >
              <FaBars />
            </IconButton>
          </Box>
        </FloatPortal>
      )}
    </Box>
  );
};
